// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.pnpm/css-loader@0.28.7/node_modules/css-loader/index.js??ref--1-oneOf-3-1!../../node_modules/.pnpm/sass-loader@6.0.7_node-sass@7.0.3_webpack@3.8.1/node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./theme.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../node_modules/.pnpm/style-loader@0.19.0/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/.pnpm/css-loader@0.28.7/node_modules/css-loader/index.js??ref--1-oneOf-3-1!../../node_modules/.pnpm/sass-loader@6.0.7_node-sass@7.0.3_webpack@3.8.1/node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./theme.scss", function() {
			var newContent = require("!!../../node_modules/.pnpm/css-loader@0.28.7/node_modules/css-loader/index.js??ref--1-oneOf-3-1!../../node_modules/.pnpm/sass-loader@6.0.7_node-sass@7.0.3_webpack@3.8.1/node_modules/sass-loader/lib/loader.js??ref--1-oneOf-3-2!./theme.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/Theme/theme.scss
// module id = 782
// module chunks = 0